import React, { Component } from "react";
import { Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { utcToLocal } from "../../utils/dateConvert";

class DeviceTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortString: "customer",
      sortDirection: "asc",
    };
    this.sortStringName = "customer";
    this.sortDirection = "asc";
  }

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };
  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.props.sortFunction(name, order);
  };
  render() {
    const { deviceList } = this.props;
    console.log("deviceList", deviceList);
    return (
      <Table striped>
        <thead>
          <tr>
            <th>
              Name{" "}
              {this.state.sortString == "name" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("name");
                  }}
                />
              )}
            </th>
            <th style={{ minWidth: "60px" }}>
              Tag{" "}
              {this.state.sortString == "tag" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("tag");
                  }}
                />
              )}
            </th>
            <th>
              Asset{" "}
              {this.state.sortString == "asset" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("asset");
                  }}
                />
              )}
            </th>
            <th style={{ minWidth: "130px" }}>
              Customer{" "}
              {this.state.sortString == "customer" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("customer");
                  }}
                />
              )}
            </th>
            <th>IMEI </th>
            <th>SIM</th>
            <th style={{ minWidth: "80px" }}>
              Type{" "}
              {this.state.sortString == "type" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("type");
                  }}
                />
              )}
            </th>
            <th>
              Status{" "}
              {this.state.sortString == "status" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("status");
                  }}
                />
              )}
            </th>
            <th style={{ minWidth: "130px" }}>
              Software{" "}
              {this.state.sortString == "software" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("software");
                  }}
                />
              )}
            </th>
            <th>
              Firmware{" "}
              {this.state.sortString == "firmware" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("firmware");
                  }}
                />
              )}
            </th>
            <th style={{ minWidth: "130px" }}>
              Last Connected{" "}
              {this.state.sortString == "lastconnected" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("lastconnected");
                  }}
                />
              )}
            </th>
            <th style={{ minWidth: "130px" }}>
              Updated{" "}
              {this.state.sortString == "updated" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("updated");
                  }}
                />
              )}
            </th>
            <th style={{ minWidth: "130px" }}>
              Created{" "}
              {this.state.sortString == "created" ? (
                <i
                  onClick={this.handleSortDirection}
                  className={`fa ${this.state.sortDirection == "asc"
                      ? "fa-sort-amount-asc"
                      : "fa-sort-amount-desc"
                    }`}
                />
              ) : (
                <i
                  className="fa fa-exchange"
                  onClick={() => {
                    this.handleSortString("created");
                  }}
                />
              )}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {deviceList.map((device, index) => {
            return (
              <tr>
                <td>{device.name}</td>
                <td>{device.tag}</td>
                <td>{device.assetName}</td>
                <a
                  onClick={() =>
                    localStorage.setItem(
                      "customer",
                      JSON.stringify({
                        customerId: device.customerId,
                        customerName: device.customerName,
                      })
                    )
                  }
                  href={`/devices?customerId=${device.customerId}&customerName=${device.customerName}`}
                >
                  <td>{device.customerName}</td>
                </a>

                <td>{device.imei}</td>
                <td>{device.simNumber}</td>
                <td>{device.type}</td>
                <td>{device.deviceStatus}</td>
                <td>{device.software}</td>
                <td>{device.firmware}</td>
                <td>{device.lastMessageTime ? utcToLocal(device.lastMessageTime) : ''}</td>
                <td>{device.dbUpdated ? utcToLocal(device.dbUpdated) : ''}</td>
                <td>{utcToLocal(device.dbCreated)}</td>
                <td>
                  <div className="tableInline">
                    <Link to={`/editDevice/${device.id}`}>Edit</Link> |{" "}
                  </div>
                  <div className="tableInline">
                    <Link to={`/deviceDetails/${device.id}`}>Details</Link> |
                  </div>
                  <div className="tableInline">
                    {" "}
                    <Link to={`/deleteDevice/${device.id}`}>Delete</Link>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default DeviceTable;
